import { useSelector } from "react-redux";

import buildRequestDeliveryLinkUrl from "../APICalls/buildRequestDeliveryLinkUrl";
import { storeType } from "./../redux/store";

export function useGetRequestDeliveryLink() {
  const store = useSelector((state: storeType) => ({
    selectedForDelivery: state.bookDelivery.selectedForDelivery,
  }));

  const requestDeliveryLink = buildRequestDeliveryLinkUrl({
    vehicleIdentifier: store.selectedForDelivery.map(
      (vehicle) => vehicle.vehicleIdentifier
    ),
    saleCode: store.selectedForDelivery.map((vehicle) => vehicle.saleCode),
  });

  return requestDeliveryLink;
}
